import React, { useState, useEffect } from 'react'
import DataTableDemo from '../../components/generals/datatables/datatable'
import Swal from 'sweetalert2'
import Button from 'react-bootstrap/Button'
import ModalGeneric from '../../components/modals/modal'
import { getData, postData } from '../../actions/servicesHttp'
import store from '../../reducer/store'
import $ from 'jquery'
import Header from '../../components/generals/header'
import styles from '../../css/devices/Devices.module.css'
import stylesIndex from './../../css/Index.module.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Loading from '../../components/generals/loading'

export default function Groups () {
  const { user } = store.getState()
  const { t, ready } = useTranslation('groups')
  const navigate = useNavigate()
  const [groups, setGroups] = useState(null)
  const [modal, setModal] = useState(false)
  const [group, setNewGroup] = useState({
    user_id: parseInt(user.userId),
    visible: true,
    name: '',
    users: [],
    devices: []
  })
  const role = user.roles

  const getGroups = async () => {
    const response = await getData('groups', undefined, navigate)
    if (response?.status === 200) {
      const data = response?.data
      data?.forEach(element => {
        const type = element.type === 'custom' ? t('label2') : element.type === 'lease' ? t('label3') : null
        element.type = type
      })
      setGroups(data)
    } else {
      setGroups([])
    }
  }

  useEffect(() => {
    if (ready) {
      getGroups()
    }
  }, [ready])

  function handleOnChange (e) {
    setNewGroup({
      ...group,
      name: e.target.value
    })
  }

  function closeModal () {
    setModal(false)
    setNewGroup({
      ...group,
      name: ''
    })
  }

  function deleted () {
    setNewGroup({
      ...group,
      name: ''
    })
    getGroups()
  }

  const createGroup = async () => {
    $('#btnModalSucess').prop('disabled', true)

    if (group.name.trim() === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('newGroupModal.message1'),
        showConfirmButton: false,
        timer: 2500
      })
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
      return
    }

    const response = await getData('groups', undefined, navigate)
    const existingGroups = response?.data || []

    if (existingGroups.some((groups) => groups.name === group.name.trim())) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('newGroupModal.message2'),
        showConfirmButton: false,
        timer: 2500
      })
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
      deleted()
      return
    }

    const res = await postData('groups', group, navigate)

    if (res?.data?.result === true) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: t('newGroupModal.message3'),
        showConfirmButton: false,
        timer: 2500
      })
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
      getGroups()
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: t('newGroupModal.message4'),
        showConfirmButton: false,
        timer: 2500
      })
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    }

    setModal(false)
    setNewGroup({
      ...group,
      name: ''
    })
  }

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div
          className={`container-toggle ${styles.btns}`}
          style={{ display: user.range === 1 ? 'flex' : 'none' }}
        >
          {role?.groupsPage.newGroup && <Button onClick={() => setModal(true)} variant="dark">
            <i className="fas fa-users" style={{ marginRight: '0.5rem' }}></i>
            {t('label1')}
          </Button>}
        </div>
        {groups === null && <Loading color="primary" />}
        {groups !== null && <DataTableDemo
          data={
            groups && groups !== null
              ? groups.filter((group) => group.visible !== false)
              : []
          }
          reload={deleted}
          editUsers={false}
          rowStates={false}
          rowSelecteds={false}
          exportsPdf={role?.groupsPage.exportPdfGroups}
          exportsCsv={role?.groupsPage.exportCsvGroups}
          actionDelete={role?.groupsPage.removeGroups}
          actionDashboard={role?.groupsPage.seeDashboardGroup}
          table="groups"
          searchs={['name', 'type']}
          columns={[{ field: 'name', header: t('headers.one') }, { field: 'type', header: t('headers.two') }]}
          namePdf={t('namePdf')}
        />}
      </div>

      {/* MODAL PARA CREAR GRUPO */}
      <ModalGeneric
        show={modal}
        onHide={closeModal}
        id="newGroup"
        onChange={handleOnChange}
        onClose={closeModal}
        title={t('newGroupModal.title')}
        objects={[
          {
            key: 'key1',
            label: t('newGroupModal.input'),
            placeholder: t('newGroupModal.placeholder'),
            value: group.name,
            name: 'name',
            type: 'text'
          }
        ]}
        btnError={ t('newGroupModal.button2')}
        actionError={closeModal}
        btnSuccess={ t('newGroupModal.button1')}
        actionSuccess={createGroup}
      />
    </div>
  )
}
